import { clearAdminSession, getAdminToken } from "./adminAuthApi";

const API_BASE_URL = (
  process.env.REACT_APP_ADMIN_API_BASE_URL ||
  "http://secondbite-manage.localhost/admin-api/v1"
).replace(/\/+$/, "");

const request = async (path, options = {}) => {
  let response;

  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      ...options,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getAdminToken()}`,
        ...(options.body ? { "Content-Type": "application/json" } : {}),
        ...options.headers,
      },
    });
  } catch {
    throw new Error("Unable to connect to the SecondBite backend.");
  }

  const payload = await response.json().catch(() => null);

  if (response.status === 401) {
    clearAdminSession();
    window.location.replace("/login");
    throw new Error("Your session has expired.");
  }

  if (!response.ok || !payload?.success) {
    const validationMessage = payload?.errors
      ? Object.values(payload.errors).flat().find(Boolean)
      : null;
    throw new Error(validationMessage || payload?.message || "Request failed.");
  }

  return payload;
};

export const listMerchantOwners = async ({ status = "", keyword = "" } = {}) => {
  const params = new URLSearchParams({ per_page: "100" });
  if (status !== "") params.set("status", status);
  if (keyword.trim()) params.set("keyword", keyword.trim());
  return (await request(`/merchant-owners?${params}`)).data;
};

export const getMerchantOwnerMeta = async () =>
  (await request("/merchant-owners/meta")).data;

export const getMerchantOwner = async (id) =>
  (await request(`/merchant-owners/${id}`)).data;

export const createMerchantOwner = async (data) =>
  (await request("/merchant-owners", {
    method: "POST",
    body: JSON.stringify(data),
  })).data;

export const updateMerchantOwner = async (id, data) =>
  (await request(`/merchant-owners/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  })).data;

export const deleteMerchantOwner = async (id) =>
  request(`/merchant-owners/${id}`, { method: "DELETE" });
